import { Aircrafts } from '@/features/Aircrafts/Aircrafts';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const aircraftsListSearchSchema = z.object({
    q: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/aircrafts/')({
    component: Aircrafts,
    validateSearch: aircraftsListSearchSchema,
});
